import { gql } from "@outschool/ui-apollo";

export const LearnerQuizStartQuizAttempt = gql`
  mutation LearnerQuizStartQuizAttempt($quizUid: ID!) {
    startQuizAttempt(quizUid: $quizUid) {
      uid
      quizUid
      learnerUid
      attempt {
        selectedAnswers {
          questionIndex
          optionIndex
        }
        answeredCorrectByIndex {
          questionIndex
          correct
        }
        completed
      }
      createdAt
      updatedAt
    }
  }
`;

export const LearnerQuizUpdateQuizAttempt = gql`
  mutation LearnerQuizUpdateQuizAttempt(
    $attemptUid: ID!
    $attempt: QuizAttemptPatchInput!
  ) {
    updateQuizAttempt(attemptUid: $attemptUid, attempt: $attempt) {
      uid
      quizUid
      learnerUid
      attempt {
        selectedAnswers {
          questionIndex
          optionIndex
        }
        answeredCorrectByIndex {
          questionIndex
          correct
        }
        completed
      }
      createdAt
      updatedAt
    }
  }
`;

export const LearnerQuizCompleteQuizAttempt = gql`
  mutation LearnerQuizCompleteQuizAttempt($attemptUid: ID!) {
    completeQuizAttempt(attemptUid: $attemptUid) {
      uid
      quizUid
      learnerUid
      attempt {
        selectedAnswers {
          questionIndex
          optionIndex
        }
        answeredCorrectByIndex {
          questionIndex
          correct
        }
        completed
      }
      createdAt
      updatedAt
    }
  }
`;
